<template>
  <v-card v-if="Object.keys(data).length > 0" outlined>
    <v-card-text>
      <v-row>
        <v-col cols="4">
          <span class="font-weight-bold">Articles publiés : </span
          >{{ data.nb_posts_published }}
          <span class="text--secondary"
            >(dont {{ data.nb_posts_republished }} republiés)</span
          >
        </v-col>
        <v-col cols="4">
          <span class="font-weight-bold">Articles générés : </span
          >{{ data.nb_posts_generated }}
          <span class="text--secondary"
            >({{ data.nb_posts_generated_publish }} publication directe /
            {{ data.nb_posts_generated_draft }} brouillons /
            {{ data.nb_posts_generated_future }} programmés)</span
          >
        </v-col>
        <v-col cols="4">
          <span class="font-weight-bold">Ratio publiés / générés : </span
          >{{ data.post_draft_ratio }}
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <span class="font-weight-bold">Nb. articles / j (moy) : </span
          >{{ data.avg_posts_per_day }}
        </v-col>
        <v-col cols="4">
          <span class="font-weight-bold">Sessions (GA) : </span
          >{{ data.sessions }}
        </v-col>
        <v-col cols="4">
          <span class="font-weight-bold">CA (GA) : </span
          >{{ data.ca }}
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <span class="font-weight-bold">Visiteur unique (Marfeel) : </span
          >{{ data.unique_users }}
        </v-col>
        <v-col cols="4">
          <span class="font-weight-bold">Vues (Wysistat) : </span
          >{{ data.wysistat_views }}
        </v-col>
        <v-col cols="4">
          <span class="font-weight-bold">Visites (Wysistat) : </span
          >{{ data.wysistat_visits }}
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <span class="font-weight-bold">Impressions (G. Search) : </span
          >{{ data.gsc_search_prints }}
        </v-col>
        <v-col cols="4">
          <span class="font-weight-bold">Impressions (G. News) : </span
          >{{ data.gsc_news_prints }}
        </v-col>
        <v-col cols="4">
          <span class="font-weight-bold">Impressions (Discover) : </span
          >{{ data.gsc_discover_prints }}
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <span class="font-weight-bold">Clics (G. Search) : </span
          >{{ data.gsc_search_clics }}
        </v-col>
        <v-col cols="4">
          <span class="font-weight-bold">Clics (G. News) : </span
          >{{ data.gsc_news_clics }}
        </v-col>
        <v-col cols="4">
          <span class="font-weight-bold">Clics (Discover) : </span
          >{{ data.gsc_discover_clics }}
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { STATS_DEFAULT } from "@/components/ai-factory/suivi-prod-ia/tables/Results.vue";

export default {
  name: "TableStats",
  props: {
    data: {
      type: Object,
      default: () => STATS_DEFAULT,
    },
  },
  setup(props, { emit }) {
    // =>  METHODS

    // =>  COMPUTED

    // =>  WATCH

    // =>  HOOKS

    // =>  DATA
    return {};
  },
};
</script>
